import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { SuaThuChiHopDong } from "./SuaThuChiHopDong";

export const BtnSuaThuChiHopDong = ({ item,isHoaHongTraGop,isDuDungPhiPhatDongLaiTatToan,batHinhThucThanhToan }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <a href={() => false} onClick={handleShow}>
                <PopoversBootrap
                    contentText="Sửa phiếu"
                    trigger={["hover", "focus"]}
                    placement={"top"}
                >
               <img src="/app-assets/images/icon-edit-v2.png" />
                </PopoversBootrap>
            </a>
            {show && <SuaThuChiHopDong show={show} onHide={handleClose} ThuChi={item} isHoaHongTraGop={isHoaHongTraGop} isDuDungPhiPhatDongLaiTatToan={isDuDungPhiPhatDongLaiTatToan} batHinhThucThanhToan={batHinhThucThanhToan} />}
        </>
    );
};
